import { CaseDocument } from '../../data/types';
import { useAppDispatch } from '../hooks';
import { addOrReplaceCaseDocumentAction, removeCaseDocumentAction, setCaseDocumentsAction } from '../reducers/caseDocumentReducer';

export interface CaseDocumentActions {
    setCaseDocuments: (caseDocs: CaseDocument[]) => void;
    addOrReplaceCaseDocument: (caseDoc: CaseDocument) => void;
    removeCaseDocument: (docId: string) => void;
}
export const useCaseDocumentActions = (): CaseDocumentActions => {

    const dispatch = useAppDispatch();

    const setCaseDocuments = (caseDocs: CaseDocument[]) => {
        dispatch(setCaseDocumentsAction(caseDocs));
    }

    const addOrReplaceCaseDocument = (caseDoc: CaseDocument) => {
        dispatch(addOrReplaceCaseDocumentAction(caseDoc));
    }

    const removeCaseDocument = (docId: string) => {
        dispatch(removeCaseDocumentAction(docId));
    }

    return { addOrReplaceCaseDocument, setCaseDocuments, removeCaseDocument };
}
